var watchlistPositionList = {
	caption: "Beobachtungsliste Positionsliste",
	name: "Name",
	isin: "ISIN",
	lastPrice: "Letzter Kurs",
	lastPriceDateTime: "Datum/Zeit",
	perf: "Perf.",
	perfRel: "Perf. %",
	volume: "Volumen",
	tradingVolume: "Handelsvolumen",
	exchange: "Handelsplatz",
	actions: "Aktionen",
	noPositions: "Keine Ergebnisse gefunden"
};
var de = {
	watchlistPositionList: watchlistPositionList
};

export { de as default, watchlistPositionList };
